import { getErrorPayload } from '@application/common/helpers/api-helper';
import { createAsyncThunk } from '@reduxjs/toolkit';
import MaterialApi from '@infrastructure/material-api';
import { addSuccessNotification } from '../common/notificationSlice';
export const getAllMaterialByWorkOrderIdAsync = createAsyncThunk('material/GetAllMaterialOrderId', async (workOrderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await MaterialApi.getAllArticlesByWorkOrderID(workOrderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createMaterialAsync = createAsyncThunk('material/create', async (workorder, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await MaterialApi.CreateMaterial(workorder);
        dispatch(addSuccessNotification('Record succesvol aangemaakt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateMaterialAsync = createAsyncThunk('material/Update', async (material, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await MaterialApi.UpdateMaterial(material.id, material);
        dispatch(addSuccessNotification('Record succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getHoursAndMaterialByIDAsync = createAsyncThunk('material/getHoursAndMaterialByID', async (Id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await MaterialApi.getHoursAndMaterialByID(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteMaterialAsync = createAsyncThunk('material/Delete', async (Id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await MaterialApi.deleteMaterial(Id);
        dispatch(addSuccessNotification(response.data));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        rejectWithValue(getErrorPayload(error));
    }
});
export const updateMaterialPositionAsync = createAsyncThunk('material/UpdateMaterialPosition', async (position, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await MaterialApi.updateMaterialPosition(position);
        dispatch(addSuccessNotification('Material Bedrag succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateBulkMaterialAsync = createAsyncThunk('material/UpdateBulkHourAndMaterial', async (material, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await MaterialApi.updateBulkMaterial(material);
        dispatch(addSuccessNotification('Record succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
